import { createReducer } from '../../utils/misc'

import {
  FETCH_DATE_FILE_SUCCESS,
  FETCH_DATE_FILE_ERROR,
  FETCH_FILE_ERROR,
  FETCH_FILE_SUCCESS,
  FETCH_USER_FILES_REQUEST,
  FETCH_USER_FILES_SUCCESS,
  FETCH_USER_FILES_ERROR,
  OPEN_SECOND_PASSWORD_MODAL,
  CLOSE_SECOND_PASSWORD_MODAL,
  SIGN_DOCUMENT_ERROR,
  SIGN_DOCUMENT_REQUEST,
  SIGN_DOCUMENT_SUCCESS,
  FINISH_SIGNING_PROCESS_REQUEST,
  FINISH_SIGNING_PROCESS_SUCCESS,
  FINISH_SIGNING_PROCESS_ERROR,
  GET_SECOND_PASSWORD_REQUEST,
  GET_SECOND_PASSWORD_SUCCESS,
  GET_SECOND_PASSWORD_ERROR,
  UPLOAD_FILE_TED_SUCCESS,
  UPLOAD_FILE_TED_ERROR,
  CLEAN_ERROR_TED,
  UPLOADING_FILE_TED,
  SECOND_PASSWORD_RETRY,
  SECOND_PASSWORD_RETRY_RESET,
  FETCH_DECLARACION_JURADA_REQUEST,
  FETCH_DECLARACION_JURADA_SUCCESS,
  FETCH_DECLARACION_JURADA_ERROR,
  FETCH_SENDPDF_DECLARACION_JURADA_REQUEST,
  FETCH_SENDPDF_DECLARACION_JURADA_SUCCESS
} from '../constants/document'

const initialState = {
  completedDateFileUpload: false,
  completedFileUpload: false,
  fetchingUserFiles: false,
  userFiles: [],
  fetchingSecondPassword: false,
  secondPasswordSent: false,
  secondPasswordModalOpen: false,
  signingDocuments: {},
  validatingDocumentSigning: false,
  signingProcessCompleted: false,
  errorCompletingDocSigning: '',
  secondPasswordRetries: 0,
  secondPasswordError: null,
  errorUploadFile: null,
  uploadingFileTED: false,
  secondPasswordCCRPhone: '',
  fetchingDeclaracionJuradaSend: false,
  fetchingSendPdfDeclaracionJurada: false,
  idDeclaracion: null
}

export default createReducer(initialState, {
  [FETCH_DATE_FILE_SUCCESS]: state =>
    Object.assign({}, state, {
      completedDateFileUpload: true,
    }),
  [FETCH_DATE_FILE_ERROR]: state =>
    Object.assign({}, state, {
      completedDateFileUpload: false,
    }),
  [FETCH_FILE_SUCCESS]: state =>
    Object.assign({}, state, {
      completedFileUpload: true,
    }),
  [FETCH_FILE_ERROR]: state =>
    Object.assign({}, state, {
      completedFileUpload: false,
    }),
  [FETCH_USER_FILES_REQUEST]: state =>
    Object.assign({}, state, {
      fetchingUserFiles: true,
    }),
  [FETCH_USER_FILES_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingUserFiles: false,
      userFiles: payload,
    }),
  [FETCH_USER_FILES_ERROR]: state =>
    Object.assign({}, state, {
      fetchingUserFiles: false,
    }),
  [SIGN_DOCUMENT_REQUEST]: (state, payload) =>
    Object.assign({}, state, {
      signingDocuments: {
        ...state.signingDocuments,
        [payload]: {
          loading: true,
          success: false,
          error: null,
        },
      },
    }),
  [SIGN_DOCUMENT_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      signingDocuments: {
        ...state.signingDocuments,
        [payload]: {
          loading: false,
          success: true,
          error: null,
        },
      },
    }),
  [SIGN_DOCUMENT_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      signingDocuments: {
        ...state.signingDocuments,
        [payload.fileId]: {
          loading: false,
          success: payload.success,
          error: payload.error,
        },
      },
    }),
  [FINISH_SIGNING_PROCESS_REQUEST]: state =>
    Object.assign({}, state, {
      validatingDocumentSigning: true,
      errorCompletingDocSigning: '',
    }),
  [FINISH_SIGNING_PROCESS_SUCCESS]: state =>
    Object.assign({}, state, {
      validatingDocumentSigning: false,
      signingProcessCompleted: true,
      errorCompletingDocSigning: '',
    }),
  [FINISH_SIGNING_PROCESS_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      validatingDocumentSigning: false,
      signingProcessCompleted: false,
      errorCompletingDocSigning: payload,
    }),
  [OPEN_SECOND_PASSWORD_MODAL]: state =>
    Object.assign({}, state, {
      secondPasswordModalOpen: true,
      errorCompletingDocSigning: null,
    }),
  [CLOSE_SECOND_PASSWORD_MODAL]: state =>
    Object.assign({}, state, {
      secondPasswordModalOpen: false,
      errorCompletingDocSigning: null,
    }),
  [GET_SECOND_PASSWORD_REQUEST]: state =>
    Object.assign({}, state, {
      fetchingSecondPassword: true,
      secondPasswordError: null,
      secondPasswordCCRPhone: ''
    }),
  [GET_SECOND_PASSWORD_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSecondPassword: false,
      secondPasswordSent: true,
      secondPasswordError: null,
      secondPasswordCCRPhone: payload
    }),
  [GET_SECOND_PASSWORD_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSecondPassword: false,
      secondPasswordSent: false,
      secondPasswordError: payload,
      secondPasswordCCRPhone: ''
    }),
  [UPLOADING_FILE_TED]: state =>
    Object.assign({}, state, {
      errorUploadFile: null,
      uploadingFileTED: true,
    }),
  [UPLOAD_FILE_TED_SUCCESS]: state =>
    Object.assign({}, state, {
      errorUploadFile: null,
      uploadingFileTED: false,
    }),
  [UPLOAD_FILE_TED_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      errorUploadFile: payload,
      uploadingFileTED: false,
    }),
  [CLEAN_ERROR_TED]: state =>
    Object.assign({}, state, {
      errorUploadFile: null,
      uploadingFileTED: false,
    }),
  [SECOND_PASSWORD_RETRY]: state =>
    Object.assign({}, state, {
      secondPasswordRetries: state.secondPasswordRetries + 1,
    }),
  [SECOND_PASSWORD_RETRY_RESET]: state =>
    Object.assign({}, state, {
      secondPasswordRetries: 0,
    }),
  [FETCH_DECLARACION_JURADA_REQUEST]: state =>
    Object.assign({}, state, {
      fetchingDeclaracionJuradaSend: true
    }),
  [FETCH_DECLARACION_JURADA_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingDeclaracionJuradaSend: false,
      completedDateFileUpload: true,
      completedFileUpload: true,
      idDeclaracion: payload
    }),
  [FETCH_SENDPDF_DECLARACION_JURADA_REQUEST]: state =>
    Object.assign({}, state, {
      fetchingSendPdfDeclaracionJurada: true
    }),
  [FETCH_SENDPDF_DECLARACION_JURADA_SUCCESS]: state =>
    Object.assign({}, state, {
      fetchingSendPdfDeclaracionJurada: false
    })
})